<template>
  <div class="pr-t-container">
    <v-data-table
      v-if="canViewPaymentRequests"
      class="pr-t-class"
      :headers="headers"
      :search="search"
      :items="items"
      :page.sync="pageNumber"
      :loading="loading"
      :item-class="rowClass"
      @pagination="sendChangedData($event)"
    >
      <template v-slot:loading>
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>
      <template v-slot:[`item.orderNumber`]="{ item }">
        <b-link @click="viewDetailedPaymentRequest(item)">{{
          item.orderNumber
        }}</b-link>
      </template>
      <template v-slot:[`item.createdDate`]="{ item }">
        {{ formatDate(item.createdDate) }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        {{ formatStatus(item) }}
      </template>
    </v-data-table>
  </div>
</template>

<style scoped>
.pr-t-container {
  margin-top: 1rem;
}
</style>
<script>
import PaymentRequestPerimissionsMixin from "@/components/paymentrequest/PaymentRequestPermissionsMixin.js";
import dayjs from "dayjs";

export default {
  mixins: [PaymentRequestPerimissionsMixin],
  props: {
    search: {
      type: String,
      required: false
    },
    items: Array,
    loading: Boolean
  },
  data() {
    return {
      pageNumber: 1
    };
  },
  computed: {
    headers() {
      const headers = [];
      headers.push({
        text: "Date",
        value: "createdDate",
        align: "Left"
      });
      headers.push({
        text: "Order #",
        value: "orderNumber",
        align: "left"
      });
      headers.push({ text: "Recepient", value: "email", align: "left" });
      headers.push({ text: "Status", value: "status", align: "left" });
      headers.push({
        text: "Type",
        value: "paymentType",
        align: "left"
      });
      headers.push({ text: "Amount", value: "amount_currency", align: "left" });
      return headers;
    }
  },
  methods: {
    rowClass() {
      const rowClass = "table-rows";
      return rowClass;
    },
    viewDetailedPaymentRequest(item) {
      this.$emit("viewDetailedPaymentRequest", item);
    },
    sendChangedData(event) {
      this.$emit("changedData", event);
    },
    resetTable() {
      this.pageNumber = 1;
    },
    formatDate(date) {
      return dayjs(date).format("DD/MM/YYYY");
    },
    formatStandardStatus(item) {
      if (item.paymentSetup == "Yes") return "Paid";
      if (item.emailSent == "Sent") return "Sent";
      if (item.emailSent == "Not Sent" && dayjs(item.sendDate).isAfter(dayjs()))
        return "Scheduled";
      if (dayjs(item.expiryDate).isBefore(dayjs())) return "Expired";
      if (
        item.emailSent == "Not Sent" &&
        dayjs(item.sendDate).isBefore(dayjs())
      )
        return "Stuck";
      return "Error";
    },
    formatRecurringStatus(item) {
      if (item.recurringStatus == "Completed") return "Completed";
      if (item.recurringStatus == "Cancelled") return "Cancelled";
      if (
        item.recurringStatus == "OnGoing" ||
        item.recurringStatus == "Scheduled"
      )
        return "OnGoing";
      if (item.emailSent == "Sent") return "Sent";
      if (item.emailSent == "Not Sent" && dayjs(item.sendDate).isAfter(dayjs()))
        return "Scheduled";
      if (item.recurringStatus == "Pending") return "Pending";
      if (dayjs(item.expiryDate).isBefore(dayjs())) return "Expired";
      return "Error";
    },
    formatStatus(item) {
      return item.paymentType === "Recurring"
        ? this.formatRecurringStatus(item)
        : this.formatStandardStatus(item);
    }
  }
};
</script>

<style lang="scss" scoped></style>
